<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.payrollTypes')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{$ml.get('shared.settings')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.payrollTypes')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('payrollTypes.payrollTypeList')}}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div
                v-show="payrollList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="payroll in payrollList" :key="payroll.id">
                      <td>{{payroll.shortCode}}</td>
                      <td>{{payroll.name}}</td>
                      <td class="pull-right">
                        <button
                          type="button"
                          @click="getPayroll(payroll.id)"
                          class="btn btn-primary btn-sm"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="payrollList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get('payrollTypes.payrollTypeNotRecord')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{$ml.get('payrollTypes.payrollTypeInfo')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button v-show="authControl == 0"
                  type="button"
                  @click="newPayroll()"
                  class="btn btn-sm btn-warning "
                >{{$ml.get('payrollTypes.newPayrollType')}}</button>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>{{$ml.get('payrollTypes.shortCode')}}</label>
                      <input
                        v-model="selectedPayroll.shortCode"
                        type="text"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-8">
                    <div class="form-group">
                      <label>{{$ml.get('payrollTypes.payrollName')}}</label>
                      <input
                        v-model="selectedPayroll.name"
                        type="text"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>{{$ml.get('payrollTypes.payrollType')}}</label>
                      <select @change="changePayrollType($event)" class="form-control">
                        <option :selected="selectedPayroll.type==0" value="0">{{$ml.get('general.notSelected')}}</option>
                        <option :selected="selectedPayroll.type==1" value="1">{{$ml.get('payrollTypes.payrolls.normalWork')}}</option>
                        <option :selected="selectedPayroll.type==2" value="2">{{$ml.get('payrollTypes.payrolls.weekendHoliday')}}</option>
                        <option :selected="selectedPayroll.type==3" value="3">{{$ml.get('payrollTypes.payrolls.publicHoliday')}}</option>
                        <option :selected="selectedPayroll.type==4" value="4">{{$ml.get('payrollTypes.payrolls.annualPermit')}}</option>
                        <option :selected="selectedPayroll.type==5" value="5">{{$ml.get('payrollTypes.payrolls.absenteeism')}}</option>
                        <option :selected="selectedPayroll.type==6" value="6">{{$ml.get('payrollTypes.payrolls.missingHour')}}</option>
                        <option :selected="selectedPayroll.type==7" value="7">{{$ml.get('payrollTypes.payrolls.allowence')}}</option>
                        <option :selected="selectedPayroll.type==8" value="8">{{$ml.get('payrollTypes.payrolls.overtime')}}</option>
                        <option :selected="selectedPayroll.type==9" value="9">{{$ml.get('payrollTypes.payrolls.break')}}</option>
                        <option :selected="selectedPayroll.type==10" value="10">{{$ml.get('payrollTypes.payrolls.nightOvertime')}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>{{$ml.get('payrollTypes.otherPayrollType')}}</label>
                      <select @change="changeOtherPayrollType($event)" class="form-control">
                        <option :selected="selectedPayroll.otherType==0" value="0">{{$ml.get('general.notSelected')}}</option>
                        <option
                          v-for="payroll in payrollList"
                          :key="payroll.id"
                          :value="payroll.id"
                          :selected="selectedPayroll.otherType"
                        >{{payroll.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>{{$ml.get('payrollTypes.equalPayrollType')}}</label>
                      <select @change="changeEqualPayrollType($event)" class="form-control">
                        <option :selected="selectedPayroll.equalType==0" value="0">{{$ml.get('general.notSelected')}}</option>
                        <option
                          v-for="payroll in payrollList"
                          :key="payroll.id"
                          :value="payroll.id"
                          :selected="selectedPayroll.equalType == payroll.id"
                        >{{payroll.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>{{$ml.get('payrollTypes.monthlyPayrollColumn')}}</label>
                      <select @change="changeMonthlyPayroll($event)" class="form-control">
                        <option :selected="selectedPayroll.monthlyPayrollId==0" value="0">{{$ml.get('general.notSelected')}}</option>
                        <option
                          v-for="monthlyPayroll in monthlyPayrollList"
                          :key="monthlyPayroll.id"
                          :value="monthlyPayroll.id"
                          :selected="selectedPayroll.monthlyPayrollId == monthlyPayroll.id"
                        >{{monthlyPayroll.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>{{$ml.get('payrollTypes.maxLimit')}}</label>
                      <input
                        v-model="selectedPayroll.maxLimit"
                        type="text"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>{{$ml.get('payrollTypes.multiplier')}}</label>
                      <input
                        v-model="selectedPayroll.multiplier"
                        type="text"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>{{$ml.get('payrollTypes.confirmation')}}</label>
                      <span class="form-control checkbox">
                        <label style="margin-left:20px;">
                          <input
                            :checked="selectedPayroll.isApproved"
                            @change="selectedPayroll.isApproved==true ? selectedPayroll.isApproved=false : selectedPayroll.isApproved=true"
                            type="checkbox"
                          />
                          {{$ml.get('payrollTypes.confirmationRequired')}}
                        </label>
                      </span>
                    </div>
                  </div>
                  <hr />
                  <div class="col-sm-12" align="center" style="margin-bottom:10px;">
                    <h4>{{$ml.get('payrollTypes.tolerances')}}</h4>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group" style="margin-bottom:10px;">
                      <label class="input-group-addon">
                        <strong>{{$ml.get('payrollTypes.firstTolerance')}} :</strong>
                      </label>
                      <input
                        v-model="selectedPayroll.firstTolerance1"
                        type="number"
                        min="0"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group" style="margin-bottom:10px;">
                      <label class="input-group-addon">
                        <strong>{{$ml.get('payrollTypes.lastTolerance')}} :</strong>
                      </label>
                      <input
                        v-model="selectedPayroll.lastTolerance1"
                        type="number"
                        min="0"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group" style="margin-bottom:10px;">
                      <label class="input-group-addon">
                        <strong>{{$ml.get('payrollTypes.totalTolerance')}} :</strong>
                      </label>
                      <input
                        v-model="selectedPayroll.totalTolerance1"
                        type="number"
                        min="0"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group" style="margin-bottom:10px;">
                      <label class="input-group-addon">
                        <strong>{{$ml.get('payrollTypes.firstTolerance')}} :</strong>
                      </label>
                      <input
                        v-model="selectedPayroll.firstTolerance2"
                        type="number"
                        min="0"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group" style="margin-bottom:10px;">
                      <label class="input-group-addon">
                        <strong>{{$ml.get('payrollTypes.lastTolerance')}} :</strong>
                      </label>
                      <input
                        v-model="selectedPayroll.lastTolerance2"
                        type="number"
                        min="0"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group" style="margin-bottom:10px;">
                      <label class="input-group-addon">
                        <strong>{{$ml.get('payrollTypes.totalTolerance')}} :</strong>
                      </label>
                      <input
                        v-model="selectedPayroll.totalTolerance2"
                        type="number"
                        min="0"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group" style="margin-bottom:10px;">
                      <label class="input-group-addon">
                        <strong>{{$ml.get('payrollTypes.firstTolerance')}} :</strong>
                      </label>
                      <input
                        v-model="selectedPayroll.firstTolerance3"
                        type="number"
                        min="0"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group" style="margin-bottom:10px;">
                      <label class="input-group-addon">
                        <strong>{{$ml.get('payrollTypes.lastTolerance')}} :</strong>
                      </label>
                      <input
                        v-model="selectedPayroll.lastTolerance3"
                        type="number"
                        min="0"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group" style="margin-bottom:10px;">
                      <label class="input-group-addon">
                        <strong>{{$ml.get('payrollTypes.totalTolerance')}} :</strong>
                      </label>
                      <input
                        v-model="selectedPayroll.totalTolerance3"
                        type="number"
                        min="0"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="overlay" id="load" :hidden="!isLoadingDetail">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-footer">
                <div class="pull-right">
                  <button
                    v-show="!isNewPayroll && authControl == 0"
                    type="button"
                    data-toggle="modal"
                    data-target="#modal-sil"
                    class="btn btn-sm btn-danger "
                    style="margin: 5px; width:120px;"
                  >{{$ml.get('general.delete')}}</button>
                  <button
                    v-show="isNewPayroll && authControl == 0"
                    type="button"
                    data-toggle="modal"
                    data-target="#modal-kaydet"
                    class="btn btn-sm btn-success "
                    style="margin: 5px; width:120px;"
                  >{{$ml.get('general.save')}}</button>
                  <button
                    v-show="!isNewPayroll && authControl == 0"
                    type="button"
                    data-toggle="modal"
                    data-target="#modal-guncelle"
                    class="btn btn-sm btn-success "
                    style="margin: 5px; width:120px;"
                  >{{$ml.get('general.update')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.update')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.selectedPayroll.shortCode}} - {{this.selectedPayroll.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('payrollTypes.isContinuePayrollTypeUpdate')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="savePayroll()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.save')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{this.selectedPayroll.shortCode}} - {{this.selectedPayroll.name}}</p>
              <span>{{$ml.get('payrollTypes.isContinuePayrollTypeSave')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="savePayroll()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.delete')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.selectedPayroll.shortCode}} - {{this.selectedPayroll.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('payrollTypes.isContinuePayrollTypeDelete')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="deletePayroll()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      selectedPayroll: {
        id: null,
        shortCode: "",
        name: "",
        type: 0,
        otherType: 0,
        equalType: 0,
        monthlyPayrollId: 0,
        maxLimit: 450,
        multiplier: 100,
        isApproved: false,
        firstTolerance1: 0,
        lastTolerance1: 0,
        totalTolerance1: 0,
        firstTolerance2: 0,
        lastTolerance2: 0,
        totalTolerance2: 0,
        firstTolerance3: 0,
        lastTolerance3: 0,
        totalTolerance3: 0
      },
      payrolls: [],
      monthlyPayrolls: [],
      isNewPayroll: true
    };
  },
  computed: {
    authControl(){
      return this.$store.getters.getAuthAyarlar;
    },
    payrollList() {
      return this.payrolls;
    },
    monthlyPayrollList() {
      return this.monthlyPayrolls;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    changePayrollType(event) {
      this.selectedPayroll.type = event.target.value;
    },
    changeOtherPayrollType(event) {
      this.selectedPayroll.otherType = event.target.value;
    },
    changeEqualPayrollType(event) {
      this.selectedPayroll.equalType = event.target.value;
    },
    changeMonthlyPayroll(event) {
      this.selectedPayroll.monthlyPayrollId = event.target.value;
    },
    newPayroll() {
      this.isLoadingDetail = true;
      this.isNewPayroll = true;
      this.selectedPayroll.id = null;
      this.selectedPayroll.shortCode = "";
      this.selectedPayroll.name = "";
      this.selectedPayroll.type = 0;
      this.selectedPayroll.otherType = 0;
      this.selectedPayroll.equalType = 0;
      this.selectedPayroll.monthlyPayrollId = 0;
      this.selectedPayroll.maxLimit = 450;
      this.selectedPayroll.multiplier = 100;
      this.selectedPayroll.isApproved = false;
      this.selectedPayroll.firstTolerance1 = 0;
      this.selectedPayroll.lastTolerance1 = 0;
      this.selectedPayroll.totalTolerance1 = 0;
      this.selectedPayroll.firstTolerance2 = 0;
      this.selectedPayroll.lastTolerance2 = 0;
      this.selectedPayroll.totalTolerance2 = 0;
      this.selectedPayroll.firstTolerance3 = 0;
      this.selectedPayroll.lastTolerance3 = 0;
      this.selectedPayroll.totalTolerance3 = 0;
      this.isLoadingDetail = false;
    },
    async savePayroll() {
      if (
        this.selectedPayroll.name == "" ||
        this.selectedPayroll.shortCode == ""
      ) {
        alertify.warning(this.$ml.get('alerts.pleaseEnterShortCodeAndName'));
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewPayroll) {
        try {
          let selectedPayroll2 = this.selectedPayroll;
          const response = await this.$axios
            .post("/Payroll", {
              shortCode: selectedPayroll2.shortCode,
              name: selectedPayroll2.name,
              type: selectedPayroll2.type,
              otherPayrollTypes: parseInt(selectedPayroll2.otherType),
              equalPayroll: parseInt(selectedPayroll2.equalType),
              monthlyPayroll: parseInt(selectedPayroll2.monthlyPayrollId),
              isApproved: selectedPayroll2.isApproved,
              maxLimit: selectedPayroll2.maxLimit,
              multiplier: selectedPayroll2.multiplier,
              firstTolerance1: selectedPayroll2.firstTolerance1,
              lastTolerance1: selectedPayroll2.lastTolerance1,
              totalTolerance1: selectedPayroll2.totalTolerance1,
              firstTolerance2: selectedPayroll2.firstTolerance2,
              lastTolerance2: selectedPayroll2.lastTolerance2,
              totalTolerance2: selectedPayroll2.totalTolerance2,
              firstTolerance3: selectedPayroll2.firstTolerance3,
              lastTolerance3: selectedPayroll2.lastTolerance3,
              totalTolerance3: selectedPayroll2.totalTolerance3
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.savedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getPayrolls();
          this.getPayroll(id);
          this.isNewDevice = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let selectedPayroll2 = this.selectedPayroll;
          const response = await this.$axios
            .post("/Payroll/" + selectedPayroll2.id, {
              shortCode: selectedPayroll2.shortCode,
              name: selectedPayroll2.name,
              type: selectedPayroll2.type,
              otherPayrollTypes: parseInt(selectedPayroll2.otherType),
              equalPayroll: parseInt(selectedPayroll2.equalType),
              monthlyPayroll: parseInt(selectedPayroll2.monthlyPayrollId),
              isApproved: selectedPayroll2.isApproved,
              maxLimit: selectedPayroll2.maxLimit,
              multiplier: selectedPayroll2.multiplier,
              firstTolerance1: selectedPayroll2.firstTolerance1,
              lastTolerance1: selectedPayroll2.lastTolerance1,
              totalTolerance1: selectedPayroll2.totalTolerance1,
              firstTolerance2: selectedPayroll2.firstTolerance2,
              lastTolerance2: selectedPayroll2.lastTolerance2,
              totalTolerance2: selectedPayroll2.totalTolerance2,
              firstTolerance3: selectedPayroll2.firstTolerance3,
              lastTolerance3: selectedPayroll2.lastTolerance3,
              totalTolerance3: selectedPayroll2.totalTolerance3
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getPayrolls();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      }
    },
    async deletePayroll() {
      try {
        this.isLoadingDetail = true;
        let id = this.selectedPayroll.id;
        const response = await this.$axios
          .delete("/Payroll/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getPayrolls();
        this.newPayroll();
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async getPayroll(id) {
      try {
        this.isLoadingDetail = true;
        const response = await this.$axios
          .get("/Payroll/" + id)
          .then(response => {
            this.isNewPayroll = false;
            this.selectedPayroll.id = id;
            this.selectedPayroll.shortCode = response.data.shortCode;
            this.selectedPayroll.name = response.data.name;
            this.selectedPayroll.type = response.data.type;
            this.selectedPayroll.otherType = response.data.otherPayrollTypes;
            this.selectedPayroll.equalType = response.data.equalPayroll;
            this.selectedPayroll.monthlyPayrollId =
              response.data.monthlyPayroll;
            this.selectedPayroll.maxLimit = response.data.maxLimit;
            this.selectedPayroll.multiplier = response.data.multiplier;
            this.selectedPayroll.isApproved = response.data.isApproved;
            this.selectedPayroll.firstTolerance1 =
              response.data.firstTolerance1;
            this.selectedPayroll.lastTolerance1 = response.data.lastTolerance1;
            this.selectedPayroll.totalTolerance1 =
              response.data.totalTolerance1;
            this.selectedPayroll.firstTolerance2 =
              response.data.firstTolerance2;
            this.selectedPayroll.lastTolerance2 = response.data.lastTolerance2;
            this.selectedPayroll.totalTolerance2 =
              response.data.totalTolerance2;
            this.selectedPayroll.firstTolerance3 =
              response.data.firstTolerance3;
            this.selectedPayroll.lastTolerance3 = response.data.lastTolerance3;
            this.selectedPayroll.totalTolerance3 =
              response.data.totalTolerance3;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async getPayrolls() {
      try {
        this.isLoading = true;
        const payrolls = [];
        const response = await this.$axios
          .get("/Payroll")
          .then(response => {
            response.data.forEach(doc => {
              payrolls.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                type: doc.type,
                otherType: doc.otherPayrollTypes,
                equalType: doc.equalPayroll,
                maxLimit: doc.maxLimit,
                monthlyPayrollId: doc.monthlyPayroll,
                isApproved: doc.isApproved,
                multiplier: doc.multiplier,
                firstTolerance1: doc.firstTolerance1,
                lastTolerance1: doc.lastTolerance1,
                totalTolerance1: doc.totalTolerance1,
                firstTolerance2: doc.firstTolerance2,
                lastTolerance2: doc.lastTolerance2,
                totalTolerance2: doc.totalTolerance2,
                firstTolerance3: doc.firstTolerance3,
                lastTolerance3: doc.lastTolerance3,
                totalTolerance3: doc.totalTolerance3
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.payrolls = payrolls;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getMonthlyPayrolls() {
      try {
        this.isLoadingDetail = true;
        const monthlyPayrolls = [];
        const response = await this.$axios
          .get("/MonthlyPayroll")
          .then(response => {
            response.data.forEach(doc => {
              monthlyPayrolls.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                ssk: doc.ssk,
                total: doc.total,
                work: doc.work
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.monthlyPayrolls = monthlyPayrolls;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(this.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getMonthlyPayrolls();
    await this.getPayrolls();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/payrollTypes/PayrollTypes.vue